(function () {
  // --------------------------------------------
  // Supply Infinite Scroll — page-count driven
  // --------------------------------------------

  const HARD_LOCK_GRID_SELECTOR = '.grid-uniform';
  const DEBUG = /(^|[?&])infdebug=1(&|$)/.test(location.search);
  const dlog = (...a) => { if (DEBUG) console.log('[INF]', ...a); };

  const sentinel = document.getElementById('tt-inf-scroll-sentinel');
  const loadMoreBtn = document.getElementById('tt-load-more');
  if (!sentinel) { dlog('No sentinel; exiting'); return; }

  // Read total pages from hidden input rendered by your section
  const totalPages = (() => {
    const el = document.querySelector('.eosh-total-pages');
    const n = el ? parseInt(el.value || el.getAttribute('value') || '1', 10) : 1;
    return isNaN(n) ? 1 : Math.max(1, n);
  })();

  // Current page from URL (?page=), default 1
  const url = new URL(location.href);
  let currentPage = parseInt(url.searchParams.get('page') || '1', 10);
  if (!currentPage || currentPage < 1) currentPage = 1;
  dlog('totalPages=', totalPages, 'currentPage=', currentPage);

  // Build next page URL deterministically, preserving other params (except page)
  function buildNextUrl() {
    if (currentPage >= totalPages) return null;
    const u = new URL(location.href);
    // keep other params, just bump page
    u.searchParams.set('page', String(currentPage + 1));
    return u.pathname + u.search; // relative is fine
  }

  // De-dup guards
  const SEEN_PAGE_URLS = new Set();
  const SEEN_PRODUCT_KEYS = new Set();

  function detectGrid(root = document) {
    if (HARD_LOCK_GRID_SELECTOR) {
      const el = root.querySelector(HARD_LOCK_GRID_SELECTOR);
      if (el) return el;
    }
    const candidates = ['#product-grid','.grid-uniform','.product-grid','.collection-grid','[data-products]','[data-section-type="collection-template"] .grid','main .grid','main [role="list"]'];
    for (const sel of candidates) {
      const el = root.querySelector(sel);
      if (el && el.children && el.children.length >= 2) return el;
    }
    let best=null,bestScore=0;
    root.querySelectorAll('.grid, .grid-uniform, [id*="grid"], [class*="grid"]').forEach(el=>{
      const s = el.children?el.children.length:0;
      if (s>bestScore){best=el;bestScore=s;}
    });
    return best;
  }

  const grid = detectGrid(document);
  if (!grid) {
    dlog('No grid found — showing Load more fallback.');
    if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
    return;
  }

  // Lock the item selector for Supply
  const ITEM_SELECTOR = '.grid-item, .grid__item';

  function productKeyFromElement(el) {
    const link = el.querySelector('a[href*="/products/"]');
    if (link) {
      try {
        const u = new URL(link.getAttribute('href'), location.origin);
        return u.pathname.replace(/\/+$/,'');
      } catch(_) {}
    }
    const pid = el.getAttribute?.('data-product-id') || el.getAttribute?.('data-productid');
    if (pid) return 'id:'+pid;
    return 'html:' + (el.textContent || '').slice(0,200);
  }

  // Seed seen products with what’s already on page 1
  Array.from(grid.querySelectorAll(ITEM_SELECTOR)).forEach(el=>{
    SEEN_PRODUCT_KEYS.add(productKeyFromElement(el));
  });

  function replacePagination(_fromDoc){/* not needed with page-count flow */}

  function parseHTML(html){
    const tmp = document.implementation.createHTMLDocument('');
    tmp.documentElement.innerHTML = html;
    return tmp;
  }

  function appendNewItems(fromDoc){
    const nextGrid = detectGrid(fromDoc);
    if (!nextGrid) return 0;
    const items = nextGrid.querySelectorAll(ITEM_SELECTOR);
    let added = 0;
    const frag = document.createDocumentFragment();
    items.forEach(el=>{
      const key = productKeyFromElement(el);
      if (SEEN_PRODUCT_KEYS.has(key)) return;
      SEEN_PRODUCT_KEYS.add(key);
      frag.appendChild(el.cloneNode(true));
      added++;
    });
    if (added) grid.appendChild(frag);
    dlog(`Appended ${added} new items`);
    return added;
  }

  let loading=false, done=false, inflight=0;

  async function loadNextPage(){
    if (loading || done || inflight>0) return;

    const nextUrl = buildNextUrl();
    if (!nextUrl) { finish(); return; }
    if (SEEN_PAGE_URLS.has(nextUrl)) { finish(); return; } // loop guard
    SEEN_PAGE_URLS.add(nextUrl);

    dlog('Fetching', nextUrl);
    loading=true; inflight++;
    try{
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP '+res.status);
      const html = await res.text();
      const doc = parseHTML(html);

      const added = appendNewItems(doc);
      if (!added) { finish(); return; }

      // Advance page index and reflect in URL (so back button works)
      currentPage += 1;
      const u = new URL(location.href);
      u.searchParams.set('page', String(currentPage));
      history.replaceState({}, '', u.pathname + u.search);

      // Stop when we hit the last page
      if (currentPage >= totalPages) finish();
    } catch(e){
      console.warn('Infinite scroll error:', e);
      if (loadMoreBtn) loadMoreBtn.style.display='inline-block';
      observer && observer.disconnect();
    } finally {
      inflight--; loading=false;
    }
  }

  function finish(){
    done=true;
    sentinel && (sentinel.style.display='none');
    loadMoreBtn && (loadMoreBtn.style.display='none');
    dlog('Finished — reached last page or no new items.');
  }

  const observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver((entries)=>{
        entries.forEach(entry=> entry.isIntersecting && loadNextPage());
      }, { rootMargin:'900px 0px 900px 0px', threshold:0 })
    : null;

  observer && observer.observe(sentinel);
  loadMoreBtn && loadMoreBtn.addEventListener('click', loadNextPage);

  if (DEBUG){
    const panel=document.createElement('div');
    panel.style.cssText='position:fixed;bottom:16px;right:16px;z-index:9999;background:#111;color:#fff;padding:10px 12px;border-radius:10px;font:12px/1.4 system-ui';
    panel.innerHTML = `
      <div><strong>Infinite Scroll Debug</strong></div>
      <div>Grid: ${grid.id ? '#'+grid.id : grid.className ? '.'+grid.className.split(' ').join('.') : grid.tagName.toLowerCase()}</div>
      <div>Item selector: <code>${ITEM_SELECTOR}</code></div>
      <div>Page: <code>${currentPage}</code> / <code>${totalPages}</code></div>
      <button id="inf-next" style="margin-top:8px">Load next now</button>
    `;
    document.body.appendChild(panel);
    panel.querySelector('#inf-next').addEventListener('click', loadNextPage);
  }
})();
